module.exports = __webpack_public_path__ + "static/media/clock.819298c7.svg";